<template>
  <div class="room-program">
    <el-card>
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="官方直播间管理" name="1">
          <OfficialRoomManage v-if="activeName === '1'"/>
        </el-tab-pane>

        <el-tab-pane label="官方直播间账号管理" name="2">
          <OfficialProgramManage  v-if="activeName === '2'"/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import OfficialProgramManage from '@/components/RoomProgram/OfficialProgramManage.vue'
import OfficialRoomManage from '@/components/RoomProgram/OfficialRoomManage.vue'
export default {
  components: {
    OfficialProgramManage,
    OfficialRoomManage
  },
  data() {
    return {
      activeName: '1'
    }
  },
}
</script>
<style scoped lang="scss"></style>